module.exports = __webpack_public_path__ + "static/media/sell_sales_2.85725cd7.jpg";